import { Component, Input } from '@angular/core';
import { Detalhamento } from '../detalhamento';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'store-video-produto',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent {

  @Input()
  public detalhamento: Detalhamento;

  constructor(public sanitizer: DomSanitizer) { }

  openVideo(urlVideo): void {
    window.open(urlVideo, '_blank');
}

}
